export function smoothScroll() {
	let scrollTo = document.querySelectorAll('a[href^="#"]');
	let top = 0;
	for (top = 0; top < scrollTo.length; top++) {
		scrollTo[top].addEventListener('click', function(e) {
			let hash = this.getAttribute("href");
			let elem = document.getElementById(hash.replace("#",""));

			elem.scrollIntoView({ left: 0, block: 'start', behavior: 'smooth' });
			e.preventDefault();
		});
	}
}
